import type { FaireProductEntity } from "../../entity_types/product";

export const p_zrcawstd9f: FaireProductEntity = {
  token: "p_zrcawstd9f",
  type: "product",
  name: "Yamazaki Home Steel Tray",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/27ecc4a7815b7900b07b5776d0c0a7ca94a2b42d565724412937f2b41029e143.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/883289542bda0052e5e09d8c7f0b6b0a8f7b11e40aac854fbe73f1e78f7326c2.jpeg",
  ],
  priceDollars: 11,
  description:
    "Yamazaki Home Steel Tray - a Japanese crafted, powder coated steel tray that is water and rust resistant, with silicone cushions on the bottom to protect surfaces. A sleek finish that securely holds your Homecourt essentials in place.\n\nTray measures 3.94 x 8.66 x 0.59 inches.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:15.443Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
